module.exports = {"Dashboard::tel__sms__whatsapp":"Tel","Sale::billing_notice":"The costs of this bidding process of 175.00 € will be charged to the commissioning agent upon receipt of the first purchase offer.","Page2::buyer_uploads":"Additional buyer uploads","Page2::additional_buyer_uploads":"Which other documents should the buyer upload besides ID Card and Proof of financing","uploadtype::identity_document":"Identity document","uploadtype::proof_of_financial_resources":"Proof of financing"}


//////////////////
// WEBPACK FOOTER
// ./src/app/@remax-at/locales/en.json
// module id = 464
// module chunks = 260